import React, { useState, useEffect } from "react";

function Hero() {
  const slides = [
    {
      subtitle: "Roam the Wild Heart of Africa",
      headline: "Discover Kenya’s Iconic Safaris",
      paragraph: "Experience the thrill of Maasai Mara’s wildlife and Amboseli’s majestic views. <br /> Let Fayah craft your ultimate safari adventure.",
      images: [
        "./assets/img/hero/pexels-mo-eid.jpg",
        "./assets/img/hero/pexels-pixabay-hero1.jpg",
        "./assets/img/hero/pexels-rebeca-goncalves.jpg",
      ],
      background: "./assets/img/hero/pexels-pixabay-38238.jpg",
    },
    {
      subtitle: "Indulge in Unmatched Elegance",
      headline: "Explore Qatar’s Luxury Retreats",
      paragraph: "Unwind in opulent resorts like Raffles Doha and Rixos Gulf Hotel. <br /> Fayah curates your lavish escape.",
      images: [
        "./assets/img/hero/pexels-mo-eid.jpg",
        "./assets/img/hero/pexels-pixabay-hero1.jpg",
        "./assets/img/hero/pexels-rebeca-goncalves.jpg",
      ],
      background: "./assets/img/hero/pexels-pixabay-38238.jpg",
    },
    {
      subtitle: "Bask in Coastal Bliss",
      headline: "Relax on Mombasa’s Pristine Beaches",
      paragraph: "From Sarova Whitesands to Diani’s serene shores, dive into paradise. <br /> Fayah plans your perfect beach getaway.",
      images: [
        "./assets/img/hero/pexels-mo-eid.jpg",
        "./assets/img/hero/pexels-pixabay-hero1.jpg",
        "./assets/img/hero/pexels-rebeca-goncalves.jpg",
      ],
      background: "./assets/img/hero/pexels-pixabay-38238.jpg",
    },
  ];

  // State for current slide index
  const [currentSlide, setCurrentSlide] = useState(0);

  // Automatic slide transition
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds
    return () => clearInterval(timer); // Cleanup on unmount
  }, [slides.length]);

  // Handle manual navigation
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const current = slides[currentSlide];

  return (
    <section
      className="hero-section-2 hero-2 fix bg-cover"
      style={{ backgroundImage: `url(${current.background})` }}
    >
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-6">
            <div className="hero-content">
              <span className="wow fadeInUp" style={{ color: "#00FF00" }}>
                {current.subtitle}
              </span>
              <h1 className="wow fadeInUp" data-wow-delay=".3s">
                {current.headline}
              </h1>
              <p className="wow fadeInUp" data-wow-delay=".5s">
                {current.paragraph}
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="hero-image">
              <div className="row g-4 align-items-center">
                <div className="col-md-6">
                  <div className="thumb style-1">
                    <img
                      src={current.images[0]}
                      alt="Destination"
                      className="wow img-custom-anim-right"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="thumb">
                    <img
                      src={current.images[1]}
                      alt="Destination"
                      className="wow img-custom-anim-right"
                    />
                  </div>
                  <div className="thumb mt-4">
                    <img
                      src={current.images[2]}
                      alt="Destination"
                      className="wow img-custom-anim-right"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="booking-list-area wow fadeInUp" data-wow-delay=".7s">
          <div className="booking-list">
            <div className="icon">
              <i className="fa-solid fa-location-dot"></i>
            </div>
            <div className="content">
              <h6>Location</h6>
              <div className="form-clt">
                <div className="nice-select" tabIndex="0">
                  <span className="current">Australia</span>
                  <ul className="list">
                    <li data-value="1" className="option selected focus">
                      UK
                    </li>
                    <li data-value="1" className="option">
                      Italy
                    </li>
                    <li data-value="1" className="option">
                      Japan
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="booking-list">
            <div className="icon">
              <i className="fa-light fa-calendar-days"></i>
            </div>
            <div className="content">
              <h6>Time Period</h6>
              <div className="form-clt style-2">
                <div className="nice-select" tabIndex="0">
                  <span className="current">March 07 - April 20</span>
                  <ul className="list">
                    <li data-value="1" className="option selected focus">
                      March 07 - April 20
                    </li>
                    <li data-value="1" className="option">
                      March 07 - April 20
                    </li>
                    <li data-value="1" className="option">
                      March 07 - April 20
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="booking-list">
            <div className="icon">
              <i className="fa-solid fa-flag"></i>
            </div>
            <div className="content">
              <h6>Tour Type</h6>
              <div className="form-clt style-3">
                <div className="nice-select" tabIndex="0">
                  <span className="current">Family</span>
                  <ul className="list">
                    <li data-value="1" className="option selected focus">
                      Couple
                    </li>
                    <li data-value="1" className="option">
                      Single
                    </li>
                    <li data-value="1" className="option">
                      Double
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <button className="theme-btn style-2" type="submit">
            Search Here
          </button>
        </div>
        {/* Navigation Dots */}
        <div className="slider-nav text-center mt-4">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`nav-dot ${index === currentSlide ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            ></span>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Hero;